import { useEffect, useState } from "react";

// Map consent categories to actual cookie names used by your app
const CONSENT_COOKIE_MAP = {
  google: ["_ga", "_gid", "_gat_UA-245611992-1", "_ga_5S61ET8ZM1", "_gcl_au"],
  fb: ["_fbp"],
  // Add others if needed...
};

export const DEFAULT_CONSENT = {
  google: "denied",
  fb: "denied",
  essential: "granted",
  preferential: "granted",
};

/**
 * Deletes a browser cookie by name
 *  * @param {string} name
 */
function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

/**
 * Applies or removes cookies based on consent state
 *  * @param {Record<string, string>} consentState
 */
function applyConsentCookies(consentState) {
  Object.entries(CONSENT_COOKIE_MAP).forEach(([key, cookies]) => {
    const allowed = consentState[key] === "granted";

    cookies.forEach((name) => {
      if (!allowed) {
        // Remove disallowed cookies
        deleteCookie(name);
      }
    });
  });
}

const COOKIE_KEY = "cookieConsent";

export function useCookieConsent({ initialState = {} } = {}) {
  const [consentState, setConsentState] = useState(() => {
    try {
      const saved = localStorage.getItem(COOKIE_KEY);
      return saved ? JSON.parse(saved) : initialState;
    } catch {
      return initialState;
    }
  });

  useEffect(() => {
    applyConsentCookies(consentState);
  }, [consentState]);

  /** @param {Record<string, string>} newConsent */
  const updateConsent = (newConsent) => {
    const updated = { ...consentState, ...newConsent };
    setConsentState(updated);
    try {
      localStorage.setItem(COOKIE_KEY, JSON.stringify(updated));
    } catch {
      // ignore
    }
  };

  return { updateConsent, consentState };
}

export function useDefaultConsentScriptContent() {
  // Return the same script your old package was inserting
  return `
    (function() {
      console.log("Default cookie consent script loaded");
      // Here you could add any global consent initialization
      // e.g., set window.dataLayer defaults for GTM
      window.dataLayer = window.dataLayer || [];
    })();
  `;
}
